import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { api } from '../api'
import { useAuth } from '../auth'
import { refreshUnread } from '../lib/notifications'
import { onServiceWorkerMessage, syncPush } from '../lib/push'

/**
 * Connects the service worker (public/sw.js) to the app: opens the page a tapped notification points at
 * (in place, without a reload) and marks it read, refreshes the bell when a push arrives, and registers a
 * replaced push subscription with the server (the worker has no token to do it itself).
 */
export function PwaBridge() {
  const nav = useNavigate()
  const { status, me } = useAuth()
  const signedIn = status === 'signed_in' && !!me
  const signedInRef = useRef(signedIn)
  signedInRef.current = signedIn

  useEffect(() => onServiceWorkerMessage((m) => {
    if (m.type === 't4:navigate') {
      if (m.url.startsWith('/')) nav(m.url)
      if (m.id && signedInRef.current) void api.readNotifications({ ids: [m.id] }).catch(() => undefined).then(() => refreshUnread())
    } else if (m.type === 't4:push') {
      if (signedInRef.current) void refreshUnread()
    } else if (m.type === 't4:resubscribe') {
      if (signedInRef.current) void syncPush({ force: true, oldEndpoint: m.old_endpoint }).catch((e: unknown) => console.warn('Push re-registration failed', e))
    }
  }), [nav])

  // Once signed in, make sure the server still knows this device (covers a subscription that changed while
  // no console window was open).
  const staffId = me?.staff.id
  useEffect(() => {
    if (!signedIn) return
    void syncPush().catch((e: unknown) => console.warn('Push sync failed', e))
  }, [signedIn, staffId])

  return null
}
